var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,16A8,8,0,1,0,5,8,7.9978,7.9978,0,0,0,13,16ZM13,2A6,6,0,1,1,7,8,6.0048,6.0048,0,0,1,13,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,19A13.0124,13.0124,0,0,0,0,32v1H26V32A13.0124,13.0124,0,0,0,13,19ZM2.04,31a11.0061,11.0061,0,0,1,21.92,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.92cb6fec.svg";
export { ForwardRef as ReactComponent };